import { getRailsClient } from "../client";

export const updateWatchedVideo = async ({
  levelId,
  lessonId,
  assessmentId,
}: {
  levelId: string;
  lessonId: string;
  assessmentId: string;
}) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/levels/${levelId}/lessons/${lessonId}/assessments/${assessmentId}/watched_video`;
    const { status } = await client.post(API);
    return status === 200;
  } catch (error) {
    console.error("Error sending watched video event:", error);
    throw error;
  }
};

export const updateReadTranscript = async ({
  levelId,
  lessonId,
}: {
  levelId: string;
  lessonId: string;
}) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/levels/${levelId}/lessons/${lessonId}/read_transcript`;
    const { status } = await client.put(API);
    return status === 200;
  } catch (error) {
    console.error("Error sending read transcript event:", error);
    throw error;
  }
};
